import React from 'react';
import { FormattedMessage } from 'react-intl';

const learnMore = (
    <FormattedMessage id="requestShippingModal.learnMore" defaultMessage="Learn more" />
);

const learnMoreDisclaimer = (
    <FormattedMessage id="requestShippingModal.learnMoreDisclaimer" defaultMessage="Learn more" />
);

export const shippingModal = {
    modalTitle: (
        <FormattedMessage id="requestShippingModal.modal_title" defaultMessage="Shipping Options" />
    ),
    shipTo: <FormattedMessage id="requestShippingModal.ship_to" defaultMessage="Destination" />,
    method: <FormattedMessage id="requestShippingModal.method" defaultMessage="Method" />,
    time: <FormattedMessage id="requestShippingModal.time" defaultMessage="Arrives In" />,
    price: <FormattedMessage id="requestShippingModal.price" defaultMessage="Cost" />,
    linkCta: learnMore,
    shipsFrom: function shipsFrom(address) {
        return (
            <FormattedMessage
                id="requestShippingModal.ships_from"
                defaultMessage="ships from {address}"
                values={{ address }}
            />
        );
    },
    serviceMethod: function serviceMethod(quote) {
        const buyerServiceMethodDisplay = quote.buyerServiceMethodDisplay;
        return (
            <FormattedMessage
                id="requestShippingModal.service_method"
                defaultMessage="{buyerServiceMethodDisplay}"
                values={{ buyerServiceMethodDisplay }}
            />
        );
    },
    servicesIncluded: (
        <FormattedMessage
            id="requestShippingModal.services_included"
            defaultMessage="Services Included"
        />
    ),
    courier: <FormattedMessage id="requestShippingModal.courier" defaultMessage="Courier" />,
    standardExpress: (
        <FormattedMessage
            id="requestShippingModal.standard"
            defaultMessage="Standard and Express"
        />
    ),
    frontDoor: (
        <FormattedMessage id="requestShippingModal.front_door" defaultMessage="Front Door" />
    ),
    whiteGlove: (
        <FormattedMessage id="requestShippingModal.white_glove" defaultMessage="White Glove" />
    ),
    serviceDescription: function serviceDescription(quote) {
        return (
            <FormattedMessage
                id="requestShippingModal.service_description"
                defaultMessage={`{serviceType, select,
                PARCEL {{serviceMethodType, select,
                    MESSENGER {Hand-delivered via a local messenger service at a time that is convenient for you to sign for a delivery.}
                    other {Carefully packaged and delivered via a parcel delivery service such as UPS or FedEx.}
                }}
                FREIGHT {Delivered to front door of your house or building and does not include unpacking, inspection, assembly, or installation.}
                other {Delivered to room of choice and includes unpacking, inspection, and minor assembly at your convenience.}
            } Facilitated by {is1stdibsBilledQuote, select,
                true {1stdibs}
                other {seller}
            }.`}
                values={{
                    serviceType: quote.serviceMethod.serviceType,
                    serviceMethodType: quote.serviceMethod.serviceMethodType,
                    is1stdibsBilledQuote: quote.is1stdibsBilledQuote,
                }}
            />
        );
    },
    requestShippingQuoteLink: (
        <FormattedMessage
            id="requestShippingModal.request_shipping_quote_link"
            defaultMessage="Request a quote"
        />
    ),
    requestShippingQuote: (
        <FormattedMessage
            id="requestShippingModal.request_shipping_quote_text"
            defaultMessage="Request a shipping quote for a different method: "
        />
    ),
    customerArranged: (
        <FormattedMessage
            id="requestShippingModal.customer_arranged"
            defaultMessage="Or, select options to pick up the item in person or arrange your own shipping at checkout."
        />
    ),
    label: function labelFormatter(label) {
        return (
            <FormattedMessage
                id="requestShippingModal.label"
                defaultMessage="{label}"
                values={{ label }}
            />
        );
    },
    someShippingMethods: (
        <FormattedMessage
            id="requestShippingModal.some_methods"
            defaultMessage="Some shipping methods may only be available upon request."
        />
    ),
    disclaimer: (
        <FormattedMessage
            id="requestShippingModal.disclaimer"
            defaultMessage="Questions about shipping methods? {linkCta}"
            values={{
                linkCta: (
                    <a
                        href="https://support.1stdibs.com/s/article/Shipping-Overview"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {learnMoreDisclaimer}
                    </a>
                ),
            }}
        />
    ),
    legal: (
        <FormattedMessage
            id="requestShippingModal.legal"
            defaultMessage="Customs duties and taxes may apply to international purchases. {linkCta}"
            values={{
                linkCta: (
                    <a
                        href="https://support.1stdibs.com/s/article/Customs-Duties-and-Taxes-for-International-Shipments"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {learnMore}
                    </a>
                ),
            }}
        />
    ),
    preDisclaimerNoQuotes: (
        <FormattedMessage
            id="requestShippingModal.pre_disclaimer_no_quotes"
            defaultMessage="Shipping quotes have not been provided for this item."
        />
    ),
    preDisclaimerStandard: (
        <FormattedMessage
            id="requestShippingModal.pre_disclaimer_standard"
            defaultMessage="Shipping somewhere else?"
        />
    ),
    preDisclaimerRequestShippingQuote: (
        <FormattedMessage
            id="requestShippingModal.pre_disclaimer_request_shipping_quote"
            defaultMessage="Need different shipping arrangements?"
        />
    ),
    blockRequest: (
        <FormattedMessage
            id="requestShippingModal.blockRequest"
            defaultMessage="If you need expedited shipping or a different method, contact the seller."
        />
    ),
};
